import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['enableJoin', 'joinLink', 'publicEvents', 'eventsLink']

  initialize() {
    this.displayJoinLink()
    this.displayEventsLink()
  }

  displayJoinLink() {
    if (!this.hasEnableJoinTarget || !this.hasJoinLinkTarget) return
    if (this.enableJoinTarget.checked) {
      this.joinLinkTarget.classList.remove("hidden")
    } else {
      this.joinLinkTarget.classList.add("hidden")
    }
  }

  displayEventsLink() {
    if (!this.hasPublicEventsTarget || !this.hasEventsLinkTarget) return
    if (this.publicEventsTarget.checked) {
      this.eventsLinkTarget.classList.remove("hidden")
    } else {
      this.eventsLinkTarget.classList.add("hidden")
    }
  }
}
